/* eslint-disable import/prefer-default-export */

export const composeAddress = (street, city) =>
  street && city ? `${city}, ${street}` : '';
